// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `th {
	font-weight: lighter; font-size: smaller;
}`, "",{"version":3,"sources":["webpack://./src/app/components/account-statement-list/account-statement-list.component.css"],"names":[],"mappings":"AAAA;CACC,oBAAoB,EAAE,kBAAkB;AACzC","sourcesContent":["th {\n\tfont-weight: lighter; font-size: smaller;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
